import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Header } from 'semantic-ui-react';
import { sysAPI } from '../../../../apis/SysAPI';
import { responseError } from '../../../../helpers';
import { useDispatch } from 'react-redux';
import TableFpAlpha from '../../../../components/Table';
import * as momentHelpers from '../../../../helpers/moment-helpers';
import Loading from '../../../../components/globals/Loading';

const PaidAndTrialsTable = forwardRef(({ activeIndex, startDate, endDate, areas, loading, excludeCompanies, includeCompanies, setLoading }, ref) => {
    const dispatch = useDispatch();
    const [paid, setPaid] = useState([]);
    const [trial, setTrial] = useState([]);
    const [internalLoading, setIntenalLoading] = useState(false)

    const headers = [
        {
            title: "Name",
            value: "advisor.fullName",
            align: "center"
        },
        {
            title: "Complete Processes",
            value: "completeProcesses",
            align: "center"
        },
        {
            title: "Most Used Area",
            value: "area",
            align: "center"
        },
        {
            title: "# of Logins",
            value: "advisor.timesLoggedIn",
            align: "center"
        },
        {
            title: "Last Login",
            value: "lastLogin",
            align: "center"
        },
    ]

    const getData = async () => {
        setLoading(true);
        setIntenalLoading(true);
        try {
            const { data } = await sysAPI.get(`/advisors/graphics/weekly-processes-table`, {
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    isPeriod: true,
                    companies: includeCompanies.join(','),
                    excludeCompanies: excludeCompanies.join(','),
                },
            });
            setPaid(data?.subscribed || []);
            setTrial(data?.trial || []);
        } catch (error) {
            responseError(error, undefined, 'PaidAndTrialsTable.getData', dispatch);
        }
        setLoading(false);
        setIntenalLoading(false);
    };

    useImperativeHandle(ref, () => ({
        getData: getData,
    }));

    useEffect(() => {
        getData();

        // eslint-disable-next-line
    }, [activeIndex]);

    return (
        <div className='card_metrics'>
            {internalLoading ? <>
                <Loading />
            </> : <>
                {paid.length > 0 &&
                    <div style={{marginBottom: "20px"}}>
                        <Header textAlign="center" as="h3">
                            Paids
                        </Header>
                        <div>
                            <TableFpAlpha
                                headers={headers}
                                data={paid}
                                positionHeaders='center'
                            >
                                <div slot={"lastLogin"} render={({ data }) => (
                                    <>{momentHelpers.dateFormatting(data.lastLogin)}</>
                                )} />
                                <div slot={"area"} render={({ data }) => (
                                    <>{data.area?.join(", ")}</>
                                )} />
                            </TableFpAlpha>

                        </div>
                    </div>
                }
                {trial.length>0 &&
                    <div>
                        <Header textAlign="center" as="h3">
                            Trials
                        </Header>
                        <div>
                            <TableFpAlpha
                                headers={headers}
                                data={trial}
                                positionHeaders='center'
                            >
                                <div slot={"lastLogin"} render={({ data }) => (
                                    <>{momentHelpers.dateFormatting(data.lastLogin)}</>
                                )} />
                                <div slot={"area"} render={({ data }) => (
                                    <>{data.area?.join(", ")}</>
                                )} />
                            </TableFpAlpha>
                        </div>
                    </div>
                }
            </>}
        </div>
    );
});

export default PaidAndTrialsTable;
